export default __webpack_public_path__ + "static/media/Ballroll_00269.3638184f.png";